// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[2].use[1]!../../../../node_modules/postcss-loader/dist/cjs.js!../../../components/library/style/colors.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AmDsbK0mU6uG32ZAUZ4V {
    padding: 0;
    width: 100%;
    box-sizing: border-box;
}

.FZxdTTxpMgXWaXpgNtnf {
    width: 100%;
    padding: 24px 16px 8px;
    box-sizing: border-box;

    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: flex-start;

    border-bottom: 1px solid ${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-gray-light"]};
}

.qUrVbd5ACpXI98_dWstd {
    margin-top: 0;
    margin-bottom: 4px;
    font-weight: 500;
}

.JC1WMaq2E18b8m_XL29n {
    margin-top: 4px;
}

._kIkUCOIASba4dvIrUc5 {
    width: 100%;
    padding: 24px 16px 8px;
    box-sizing: border-box;
    max-height: 50vh;
    overflow-y: scroll;
    scrollbar-color: rgba(0, 0, 0, 0.1) transparent; /* thumb and track color */
    scrollbar-width: 2px;
}

._kIkUCOIASba4dvIrUc5::-webkit-scrollbar {
    width: 8px;  /* for vertical scrollbars */
}

._kIkUCOIASba4dvIrUc5::-webkit-scrollbar-thumb {
    background: rgba(0, 0, 0, 0.1);
    border-radius: 8px;
}

.X0aj5AIoc6KuS0PKASwJ, .LQ40DXdMoqj96gjZquRx {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
}

.X0aj5AIoc6KuS0PKASwJ {
    margin-bottom: 24px;
}

.JXhvfpIeGR1ZjtHVaegQ {
    width: 42px;
    height: 42px;
    border-radius: 42px;

    display: flex;
    justify-content: center;
    align-items: center;

    margin-right: 16px;
}

.m6xG9jWdVOVI5UXHemBZ {
    font-weight: 500;
    margin: 0;
}

.AnCu7quoNmbnNA9po41i {
    color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-text-subtle"]};
    font-size: 14px;
    margin: 0;
}

.qV33ur6zLcIaf4qvvgf_ {
    width: 100%;
    margin: 0;
    text-align: right;
}

.nSXm5_t8UuFHFF3NsIW5 {
    background-color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-success-light"]};
    color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-success-dark"]};
}

.xpB7_mHLbIplP8JYEeDh {
    background-color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-purple-bg"]};
    color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-purple-dark"]};
}

.avEg1ETH4HBPS2C3vKKv {
    background-color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-error-light"]};
    color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-error-dark"]};
}

.z3D0A5ZTe80Y0mdKFuMb {
    transition: .3s;
}

.z3D0A5ZTe80Y0mdKFuMb:hover {
    color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-purple"]};
    cursor: pointer;
}

.etxFrn7hv2duo2upV_ya {
    text-align: right;
}
`, "",{"version":3,"sources":["webpack://./src/views/Dashboard/DashboardHistory/DashboardHistory.module.css"],"names":[],"mappings":"AAGA;IACI,UAAU;IACV,WAAW;IACX,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,sBAAsB;IACtB,sBAAsB;;IAEtB,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,uBAAuB;;IAEvB,qEAAyC;AAC7C;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,sBAAsB;IACtB,sBAAsB;IACtB,gBAAgB;IAChB,kBAAkB;IAClB,+CAA+C,EAAE,0BAA0B;IAC3E,oBAAoB;AACxB;;AAEA;IACI,UAAU,GAAG,4BAA4B;AAC7C;;AAEA;IACI,8BAA8B;IAC9B,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;;IAEnB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;;IAEnB,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,SAAS;AACb;;AAEA;IACI,mDAAwB;IACxB,eAAe;IACf,SAAS;AACb;;AAEA;IACI,WAAW;IACX,SAAS;IACT,iBAAiB;AACrB;;AAEA;IACI,8DAAqC;IACrC,mDAAyB;AAC7B;;AAEA;IACI,8DAAiC;IACjC,mDAAwB;AAC5B;;AAEA;IACI,8DAAmC;IACnC,mDAAuB;AAC3B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,mDAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,iBAAiB;AACrB","sourcesContent":["@value colors: \"../../../components/library/style/colors.css\";\n@value color-purple-bg, color-purple, color-purple-dark, color-gray-light, color-text-subtle, color-success-light, color-success-dark, color-error-light, color-error-dark from colors;\n\n.popup {\n    padding: 0;\n    width: 100%;\n    box-sizing: border-box;\n}\n\n.header {\n    width: 100%;\n    padding: 24px 16px 8px;\n    box-sizing: border-box;\n\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n    align-items: flex-start;\n\n    border-bottom: 1px solid color-gray-light;\n}\n\n.title {\n    margin-top: 0;\n    margin-bottom: 4px;\n    font-weight: 500;\n}\n\n.description {\n    margin-top: 4px;\n}\n\n.main {\n    width: 100%;\n    padding: 24px 16px 8px;\n    box-sizing: border-box;\n    max-height: 50vh;\n    overflow-y: scroll;\n    scrollbar-color: rgba(0, 0, 0, 0.1) transparent; /* thumb and track color */\n    scrollbar-width: 2px;\n}\n\n.main::-webkit-scrollbar {\n    width: 8px;  /* for vertical scrollbars */\n}\n\n.main::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.1);\n    border-radius: 8px;\n}\n\n.transaction, .row {\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n    align-items: center;\n}\n\n.transaction {\n    margin-bottom: 24px;\n}\n\n.iconContainer {\n    width: 42px;\n    height: 42px;\n    border-radius: 42px;\n\n    display: flex;\n    justify-content: center;\n    align-items: center;\n\n    margin-right: 16px;\n}\n\n.society {\n    font-weight: 500;\n    margin: 0;\n}\n\n.subtle {\n    color: color-text-subtle;\n    font-size: 14px;\n    margin: 0;\n}\n\n.amount {\n    width: 100%;\n    margin: 0;\n    text-align: right;\n}\n\n.success {\n    background-color: color-success-light;\n    color: color-success-dark;\n}\n\n.wait {\n    background-color: color-purple-bg;\n    color: color-purple-dark;\n}\n\n.error {\n    background-color: color-error-light;\n    color: color-error-dark;\n}\n\n.close {\n    transition: .3s;\n}\n\n.close:hover {\n    color: color-purple;\n    cursor: pointer;\n}\n\n.left {\n    text-align: right;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"colors": `"../../../components/library/style/colors.css"`,
	"color-purple-bg": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-purple-bg"]}`,
	"color-purple": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-purple"]}`,
	"color-purple-dark": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-purple-dark"]}`,
	"color-gray-light": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-gray-light"]}`,
	"color-text-subtle": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-text-subtle"]}`,
	"color-success-light": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-success-light"]}`,
	"color-success-dark": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-success-dark"]}`,
	"color-error-light": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-error-light"]}`,
	"color-error-dark": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-error-dark"]}`,
	"popup": `AmDsbK0mU6uG32ZAUZ4V`,
	"header": `FZxdTTxpMgXWaXpgNtnf`,
	"title": `qUrVbd5ACpXI98_dWstd`,
	"description": `JC1WMaq2E18b8m_XL29n`,
	"main": `_kIkUCOIASba4dvIrUc5`,
	"transaction": `X0aj5AIoc6KuS0PKASwJ`,
	"row": `LQ40DXdMoqj96gjZquRx`,
	"iconContainer": `JXhvfpIeGR1ZjtHVaegQ`,
	"society": `m6xG9jWdVOVI5UXHemBZ`,
	"subtle": `AnCu7quoNmbnNA9po41i`,
	"amount": `qV33ur6zLcIaf4qvvgf_`,
	"success": `nSXm5_t8UuFHFF3NsIW5`,
	"wait": `xpB7_mHLbIplP8JYEeDh`,
	"error": `avEg1ETH4HBPS2C3vKKv`,
	"close": `z3D0A5ZTe80Y0mdKFuMb`,
	"left": `etxFrn7hv2duo2upV_ya`
};
export default ___CSS_LOADER_EXPORT___;
